/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useState, useRef } from 'react'
import PropTypes from 'prop-types'
import { useDispatch, useSelector } from 'react-redux'
import brandLogo from '../assets/images/ic_logo_red.svg'
import HelpIcon from '@mui/icons-material/HelpSharp'
import {
  BrandLogoWrapper,
  BrandLogo,
  StyledLayoutHeader,
  NavTaskIcon,
  VendorPipelineIcon,
  StyledToolbar,
  StyledListItem,
  ListWrapper,
  LogoutIcon,
  NationalBrandIcon,
  NBRDashboardIcon,
  SupportFormIcon,
} from './LayoutStyle'
import NotificationsIcon from '@material-ui/icons/Notifications'
import {
  Menu,
  MenuItem,
  IconButton,
  Badge,
  ListItemText as MuiListItemText,
} from '@material-ui/core'
import {
  useScrollTrigger,
  Tooltip,
  ListItemAvatar,
  ListItemIcon,
  ListItemText,
  ListItem,
  Avatar,
} from '@material-ui/core'
import { useStyle } from './style/Layout'
import { Link as RouterLink, NavLink } from 'react-router-dom'
import { isTPlus } from '../Auth/Auth'
import NotificationDrawer from '../../components/Notification/Notification'

function ElevationScroll(props) {
  const { children, window } = props
  const trigger = useScrollTrigger({
    disableHysteresis: true,
    threshold: 0,
    target: window ? window() : undefined,
  })

  return React.cloneElement(children, {
    elevation: trigger ? 4 : 0,
  })
}

const LayoutHeader = (props) => {
  //Auth Correction
  const { displayName, company, firstName, lastName } = useSelector(
    (state) => state.auth
  )
  const classes = useStyle()
  const dispatch = useDispatch()
  const [selectedIndex, setSelectedIndex] = useState(0)
  const [userMenuAnchor, setUserMenuAnchor] = useState(null)
  const { nbrVendorConfirm, logout } = props

  const displayNavMenu = () => {
    return (
      <StyledToolbar>
        <div className="header-left">
          <BrandLogoWrapper>
            <BrandLogo src={brandLogo} alt="logo" />
          </BrandLogoWrapper>
          <ListWrapper>{getMenuButtons()}</ListWrapper>
        </div>
        <div className="header-right">
          {/* Notification Bell */}
          <NotificationDrawer />
          {/* User Menu */}
          <IconButton
            color="inherit"
            onClick={(e) => setUserMenuAnchor(e.currentTarget)}
            aria-controls="user-menu"
            aria-haspopup="true"
          >
            <Avatar style={{ color: '#ac0000', backgroundColor: 'white' }}>
              {firstName?.charAt(0) + lastName?.charAt(0)}
            </Avatar>
          </IconButton>
          <Menu
            id="user-menu"
            anchorEl={userMenuAnchor}
            keepMounted
            open={Boolean(userMenuAnchor)}
            onClose={() => setUserMenuAnchor(null)}
            getContentAnchorEl={null}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            transformOrigin={{ vertical: 'top', horizontal: 'right' }}
          >
            <MenuItem disabled>
              <MuiListItemText
                primary={<span style={{ fontWeight: 700 }}>{displayName}</span>}
                secondary={
                  <>
                    <span style={{ fontSize: 12, color: '#ac0000' }}>
                      Logged in as
                    </span>
                    <br />
                    <span style={{ fontSize: 13 }}>{company}</span>
                  </>
                }
              />
            </MenuItem>
            <MenuItem
              onClick={() => {
                setUserMenuAnchor(null)
                dispatch(logout())
              }}
            >
              Logout
            </MenuItem>
          </Menu>
        </div>
      </StyledToolbar>
    )
  }

  const handleListItemClick = (event, index) => {
    setSelectedIndex(index)
  }

  // getLogoutButton is now replaced by the user menu above

  const headersData = [
    {
      label: 'Tasks',
      href: '/',
      icon: <NavTaskIcon />,
      show: !isTPlus,
    },
    {
      label: 'Pipeline',
      href: '/Pipeline',
      icon: <VendorPipelineIcon />,
      show: !isTPlus,
    },
    {
      label: 'Projects',
      href: '/projects',
      icon: <NationalBrandIcon />,
      show: nbrVendorConfirm || isTPlus,
    },
    {
      label: 'Dashboard',
      href: '/dashboard',
      icon: <NBRDashboardIcon />,
      show: nbrVendorConfirm || isTPlus,
    },
    {
      label: 'Support',
      href: '/support',
      icon: <SupportFormIcon />,
      show: true,
    },
    {
      label: 'Help',
      href: require('../assets/onboarding/onboarding.pdf'),
      icon: <HelpIcon style={{ color: '#fff' }} />,
      show: isTPlus,
      target: '_blank',
      linkComponent: 'a',
    },
  ]

  const CustomLink = ({
    href,
    target,
    icon,
    label,
    classes,
    linkComponent,
  }) => {
    // Decide which component to use
    const Link = linkComponent || NavLink

    // Common props for both link types
    const linkProps = {
      className: classes.navLink,
      ...(target ? { href, target } : { to: href }),
    }

    return (
      <Link {...linkProps}>
        <ListItemIcon>{icon}</ListItemIcon>
        <ListItemText primary={label} />
      </Link>
    )
  }

  const getMenuButtons = () => {
    return headersData.map(
      ({ label, href, icon, show, target, linkComponent }, index) => {
        if (!show) return null
        return (
          <Tooltip key={label} title={label} placement="right-start" arrow>
            <StyledListItem
              button
              key={label}
              onClick={(event) => handleListItemClick(event, index)}
            >
              <CustomLink
                href={href}
                target={target}
                icon={icon}
                label={label}
                classes={classes}
                linkComponent={linkComponent}
              />
            </StyledListItem>
          </Tooltip>
        )
      }
    )
  }

  return (
    <>
      <ElevationScroll {...props}>
        <StyledLayoutHeader>{displayNavMenu()}</StyledLayoutHeader>
      </ElevationScroll>
    </>
  )
}

export default LayoutHeader
